/**
 * Section Tabs Scroll Spy
 * Highlights navigation tabs based on scroll position
 */

;(function () {
  'use strict'

  const SCROLL_MARGIN = 200 // matches CSS scroll-margin-top

  /**
   * Check if element is visible (not display: none or visibility: hidden)
   */
  function isElementVisible(element) {
    if (!element) return false
    const style = window.getComputedStyle(element)
    return style.display !== 'none' && style.visibility !== 'hidden' && element.offsetParent !== null
  }

  /**
   * Get visible sections (filters out links that are hidden, like #sidebar on desktop)
   */
  function getVisibleSections(tabLinks) {
    const sections = []
    tabLinks.forEach(function (link) {
      // Check if the link itself is visible (important for mobile-only #sidebar)
      const linkItem = link.closest('.rd-camp-section-tabs__item')
      if (!isElementVisible(linkItem)) {
        return
      }

      const href = link.getAttribute('href')
      if (href && href.startsWith('#')) {
        const section = document.getElementById(href.slice(1))
        if (section) {
          sections.push({
            id: href,
            element: section,
            link: link
          })
        }
      }
    })
    return sections
  }

  /**
   * Initialize scroll spy for section tabs
   */
  function initSectionTabsScroll() {
    const tabsList = document.querySelector('.rd-camp-section-tabs__list')
    const tabLinks = document.querySelectorAll('.rd-camp-section-tabs__link')

    if (!tabLinks.length || !tabsList) {
      return
    }

    var sections = []
    var currentActiveId = null

    /**
     * Scroll active tab into view within the horizontal tabs container
     */
    function scrollTabIntoView(link) {
      const listRect = tabsList.getBoundingClientRect()
      const linkRect = link.getBoundingClientRect()

      // Check if tab is outside visible area
      if (linkRect.left < listRect.left || linkRect.right > listRect.right) {
        link.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        })
      }
    }

    /**
     * Set active tab by section id
     */
    function setActiveTab(sectionId) {
      if (sectionId === currentActiveId) {
        return
      }

      currentActiveId = sectionId

      // Remove aria-current from all tabs
      tabLinks.forEach(function (link) {
        link.removeAttribute('aria-current')
      })

      // Set aria-current on matching tab and scroll it into view
      sections.forEach(function (section) {
        if (section.id === sectionId) {
          section.link.setAttribute('aria-current', 'true')
          scrollTabIntoView(section.link)
        }
      })
    }

    /**
     * Find active section based on scroll position
     * A section is active when scroll position >= section top - SCROLL_MARGIN
     * and < next section top - SCROLL_MARGIN
     */
    function updateActiveTab() {
      // Refresh visible sections (in case mobile/desktop view changed)
      sections = getVisibleSections(tabLinks)

      if (!sections.length) {
        return
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      var activeSection = null

      // Check if we're at the bottom of the page
      const isAtBottom = windowHeight + scrollTop >= documentHeight - 10

      if (isAtBottom) {
        // At bottom - select last visible section
        activeSection = sections[sections.length - 1]
      } else {
        // Normal scroll - find active section
        for (var i = 0; i < sections.length; i++) {
          const section = sections[i]
          const sectionTop = section.element.offsetTop - SCROLL_MARGIN

          if (scrollTop >= sectionTop) {
            activeSection = section
          } else {
            break
          }
        }

        // If no section is active (we're above the first section), select first visible section
        if (!activeSection) {
          activeSection = sections[0]
        }
      }

      if (activeSection) {
        setActiveTab(activeSection.id)
      }
    }

    // Listen to scroll events with passive flag for performance
    window.addEventListener('scroll', updateActiveTab, { passive: true })

    // Listen to media query changes to handle mobile/desktop switch
    const desktopMediaQuery = window.matchMedia('(min-width: 1280px)')
    desktopMediaQuery.addEventListener('change', updateActiveTab)

    // Initial check
    updateActiveTab()
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSectionTabsScroll)
  } else {
    initSectionTabsScroll()
  }
})()
